import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { defaultSitesExportFieldNames } from "~pages/Sites/SiteListPage/constants/exportFields.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useExportSites = () => {
  const { sport = "", organizationId = "" } = useParams();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) => {
      const body = {
        fieldNames: fieldNames || defaultSitesExportFieldNames,
      };
      return await request(`${sport}/o/${organizationId}/sites/export`, {
        method: "POST",
        body,
      });
    },
  });
};
